<template>
  <div class="container side-gap">
    <div class="flex-row space-between">
      <BorderlessButton href="/">
        <Logo class="logo"/>
      </BorderlessButton>
      <div class="flex-row">
        <div class="flex-row items">
          <template v-for="item in menuItems">
            <BorderlessButton :key="item.to" :href="item.to">{{$t(item.name)}}</BorderlessButton>
          </template>
        </div>
        <BorderlessButton class="lk" border="transparent" href="/personal">{{$t("personal")}}</BorderlessButton>
      </div>
    </div>
  </div>
</template>

<script>
import BorderlessButton from "@/components/BorderlessButton";
import Logo from "@/components/Logo";
import menuItems from "@/cfg/menuItems";

export default {
  name: 'NavbarDesktop',
  components: {
    BorderlessButton,
    Logo,
  },
  data: function() {
    return {
      menuItems: menuItems,
      // menuItems: [
      //   {to:"/", name:"server_predef"},
      //   {to:"/contacts", name:"about"},
      //   //{to:"/login", name:"sign_in", check: () => !this.$auth.isAuthenticated},
      //   //{to:"/personal", name:"personal", check: () => this.$auth.isAuthenticated},
      // ],
    }
  },
  watch: {
  },
  methods: {
  },
}
</script>
<style lang="scss" scoped>
.container {
  //background: red;
  //border: 1px solid red;
  height: 80px;

  display: flex;
  flex-direction: column;
  justify-content: center;

  .items {
    gap: 50px;
  }

  .lk {
    margin-left: 75px;
  }

  .logo {
    height: 21px;
  }
}

</style>
